(function() {
'use strict';

angular
    .module('TR')
    .directive('dropdownMultiSelect', function() {
    return {
        restrict: 'E',
        replace: true,

        scope: {
            caption: '@',
            model: '=',
            options: '=',
            valueName: '@',
            labelName: '@',
            classes: '@',
            ulClasses: '@'
        },

        templateUrl: 'partials/home/directivetemplate?type=dropdownmultiselect',
        transclude: true,

        link(scope, el) {
            scope.open = false;

            scope.focusIndex = -1;

            scope.selectedIndexes = [];

            scope.toggle = function(e) {
                e.preventDefault();
                if (scope.open) {
                    close();
                } else {
                    open();
                }
            };

            function open() {
                scope.open = true;
            }

            function close() {
                scope.open = false;
                scope.focusIndex = -1;
            }

            $(document).on('click.dropdownmultiselect', function(e) {
                // close panel if the click target is not a child of the element
                const isChild = el.find(e.target).length > 0;
                if (!isChild) {
                    scope.$apply(function() {
                        close();
                    });
                }
            });

           // set up watches for the model and the options
           scope.$watch('model', function(v) {
                if (v == null) {
                    return;
                }
                scope.updateOnWatch();
            }, true);

            scope.$watch('options', function(v) {
                if (v == null) {
                    return;
                }
                scope.updateOnWatch();
            }, true);

            scope.updateOnWatch = function() {
                // either the model or options have changed

                // iterate options
                _.forEach(scope.options, function(o, index) {
                    // is this option in the model array?
                    const match = _.find(scope.model, function(m) {
                        return o[scope.valueName] === m;
                    });

                    const selectedIndex = scope.selectedIndexes.indexOf(index);

                    if (_.isUndefined(match)) {
                        // remove this index
                        if (selectedIndex > -1) {
                            scope.selectedIndexes.splice(selectedIndex, 1);
                        }
                    } else if (selectedIndex === -1) {
                        // add this index
                        scope.selectedIndexes.push(index);
                    }
                });
            };

            scope.optionClick = function(index) {
                applyOption(index);
                //scope.open = false;
                el.find('a').focus();
            };

            function applyOption(index) {
                // get option at this index
                const value = scope.options[index][scope.valueName];

                // change the model
                if (scope.selectedIndexes.indexOf(index) > -1) {
                    // remove this value from the model array
                    scope.model = _.reject(scope.model, function(m) {
                        return m === value;
                    });
                } else {
                    // add this value to the model array
                    scope.model.push(value);
                }

                // set "focus" to this option
                scope.focusIndex = index;
            }

            const behaviours = {

                // Tab
                9() {
                    close();
                },

                // Escape
                27() {
                    close();
                },

                // Up Arrow
                38(e) {
                    e.preventDefault();
                    open();
                    if ((scope.focusIndex - 1) > -1) {
                        scope.focusIndex -= 1;
                    }
                },

                // Down Arrow
                40(e) {
                    e.preventDefault();
                    open();
                    if ((scope.focusIndex + 1) <= scope.options.length - 1) {
                        scope.focusIndex += 1;
                    }
                },

                // Return
                13(e) {
                    if (scope.focusIndex > -1) {
                        e.preventDefault();
                        applyOption(scope.focusIndex);
                    } else {
                        scope.toggle(e);
                    }
                }

            };

            scope.onKeydown = function(e) {
                const fn = behaviours[e.keyCode] || angular.noop;
                fn(e);
            };

            scope.$on('$destroy', function() {
                $(document).off('click.dropdownmultiselect');
            });
        }
    };
});
})();
